module.exports = __webpack_public_path__ + "static/offer-brand-basic-6-1c1c8edb690bd6855b6e4d79ce7ce90c.jpg";